module.exports = __webpack_public_path__ + "static/findahealthservice-b8df8383f6f190f504b3be627942e4d0.png";